import React, { useState } from "react";
import { Stack, Text } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { useFluentTheme } from "@theme/index";
import Link from "atoms/Link";
import TermsModal from "./TermsModal";

import facebook from "assets/facebook.png";
import yt from "assets/Shape.png";
import twitter from "assets/Path.png";

export default function SignUp() {
  const navigate = useNavigate();
  const theme = useFluentTheme();
  const [showTerms, setShowTerms] = useState(false);
  return (
    <Stack
      vertical
      verticalAlign="center"
      horizontalAlign="center"
      styles={{
        root: [{ backgroundColor: "white", width: "100%", height: "50px" }],
      }}
      gap={50}
    >
      {/* <Stack horizontal verticalAlign='center' horizontalAlign='center' gap={30}>
            <DefaultButton onClick={()=>navigate("/about")} styles={{root:[{border:'none',fontSize:'14px'}]}}>About</DefaultButton>
            <DefaultButton onClick={()=>navigate("/pricing")} styles={{root:[{border:'none',fontSize:'14px'}]}}>Pricing</DefaultButton>
            <DefaultButton onClick={()=>navigate("/getstarted")} styles={{root:[{border:'none',fontSize:'14px'}]}}>Get Started</DefaultButton>
        </Stack>
        <Stack horizontal verticalAlign='center' horizontalAlign='center' gap={40}>
            <a href="https://www.google.com"><img src={facebook} width='14px' height='17px'/></a>
            <a href="https://www.google.com"><img src={twitter} width='14px' height='17px'/></a>
            <a href="https://www.google.com"><img src={yt} width='14px' height='17px'/></a>
        </Stack> */}
      <Text
        variant="large"
        styles={{ root: [{ color: theme.palette.gray8, textAlign: "center" }] }}
      >
        <Link
          variant="Secondary"
          onClick={() => setShowTerms(true)}
          styles={{
            root: {
              fontSize: "14px", // 👈 custom font size
              fontWeight: 500, // optional
            },
          }}
        >
          Terms of Use
        </Link>
        {" "}|{" "}
        <Link
          variant="Secondary"
          onClick={() => setShowTerms(true)}
          styles={{
            root: {
              fontSize: "14px", // 👈 custom font size
              fontWeight: 500, // optional
            },
          }}
        >
          Privacy Policy
        </Link>
      </Text>
      <TermsModal showModal={showTerms} setShowModal={setShowTerms} />
    </Stack>
  );
}
